<script setup>
import {
    formataCpf,
    formataCnpj,
    formataDataFromDb,
    formataMoedaReais
} from '@kodatec/brasil-utils';
import { computed } from 'vue';

const props = defineProps({
    solicitacao: {
        type: Object,
        required: true
    }
})

const pessoafisica = import.meta.env.VITE_TIPO_PESSOA_FISICA;

const nomeBeneficiario = computed(() =>
    props.solicitacao.dados.pessoa_nome || props.solicitacao.dados.pessoa_fisica_nome
);

const detalheBeneficiario = computed(() => {
    const dados = props.solicitacao.dados;
    
    const isPessoaFisica = dados.tipo_pessoa == pessoafisica || dados.pessoa_fisica_cpf;
    if (isPessoaFisica) {
        const cpf = dados.pessoa_documento || dados.pessoa_fisica_cpf;
        return 'CPF: ' + formataCpf(cpf, false);
    } else {
        const cnpj = dados.pessoa_documento || dados.pessoa_fisica_cnpj;
        return 'CNPJ: ' + formataCnpj(cnpj, false);
    }
});

</script>

<template>
    <h3 class="text-900 font-bold text-sm mb-3 col-12">Dados da Solicitação</h3>

    <LabelDados titulo="Beneficiário" :conteudo="nomeBeneficiario" :detalhe="detalheBeneficiario" />

    <LabelDados titulo="Valor da diária" :conteudo="formataMoedaReais(solicitacao.dados.valor_unitario)" />

    <LabelDados titulo="Quantidade de diárias" :conteudo="String(solicitacao.dados.quantidade)" />

    <LabelDados titulo="Custo Final" :conteudo="formataMoedaReais(solicitacao.dados.quantidade *
        solicitacao.dados.valor_unitario)" />

    <LabelDados titulo="Objetivo da viagem" :conteudo="solicitacao.dados.objetivo_viagem" tamanho_div="col-12" />

    <hr class="w-full border-solid border-top-1 border-bottom-none surface-border my-3">

    <h3 class="text-900 font-bold text-sm mb-3 col-12">Detalhes da viagem</h3>

    <LabelDados titulo="Data de Partida" :conteudo="formataDataFromDb(solicitacao.dados.data_ida)"
        tamanho_div="col-12 lg:col-3" />

    <LabelDados titulo="Data de Retorno" :conteudo="formataDataFromDb(solicitacao.dados.data_volta)"
        tamanho_div="col-12 lg:col-3" />

    <LabelDados titulo="Origem" :conteudo="solicitacao.dados.cidade_origem" tamanho_div="col-12 lg:col-3" />

    <LabelDados titulo="Destino" :conteudo="solicitacao.dados.cidade_destino" tamanho_div="col-12 lg:col-3" />
</template>